export function combinarOpcionesSede(grupos = [], sedesIndividuales = []) {
  const opcionesGrupo = grupos.map((g) => ({
    _id: g._id,
    _tipo: "grupo",
    name: `📁 ${g.name}`,
    sedes: (g.sedes || []).map((s) => (typeof s === "string" ? s : s._id)),
  }));

  const opcionesSede = sedesIndividuales.map((s) => ({
    _id: s._id,
    _tipo: "sede",
    name: s.name,
  }));

  return [...opcionesGrupo, ...opcionesSede];
}

export function expandirSedesSeleccionadas(
  idsSeleccionados = [],
  opcionesCombinadas = [],
) {
  const resultado = new Set();

  idsSeleccionados.forEach((id) => {
    const opcion = opcionesCombinadas.find((o) => o._id === id);
    if (!opcion) return;

    if (opcion._tipo === "grupo") {
      opcion.sedes.forEach((sedeId) => resultado.add(sedeId));
    } else {
      resultado.add(opcion._id);
    }
  });

  return [...resultado];
}
